<template>
  <div class="evolution-wrapper">
    <!-- 顶部宝可梦卡片横排 -->
    <div class="pokemon-scroll-row">
      <div
        v-for="(pokemon, index) in formattedPokemons"
        :key="index"
        class="pokemon-card"
        :class="{ selected: selectedIndex === index }"
        @click="selectPokemon(index)"
      >
        <div class="pokemon-icon-wrapper">
          <img v-if="pokemon" :src="pokemon.icon_image" class="pokemon-icon" />
          <span v-else class="empty">空</span>
        </div>
      </div>
    </div>

    <!-- 当前信息显示区 -->
    <div class="main-section">
      <div class="evolution-info">
        <template v-if="evolutionResult">
          <p>当前宝可梦昵称：{{ currentPokemonNickname }}</p>
          <p v-if="evolutionResult.can_evolve">可进化为：{{ evolutionResult.evolves_to_name }}</p>
          <p v-else>无法进化</p>
        </template>
        <p v-else>请选择一只宝可梦查看是否可进化</p>
      </div>
      <button
        :disabled="!evolutionResult || !evolutionResult.can_evolve"
        @click="triggerEvolution"
      >触发进化</button>
    </div>

    <!-- 弹出提示 -->
    <div v-if="showTip" class="tip-popup">进化成功！</div>
  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
const { proxy } = getCurrentInstance();
const userId = proxy.$getUserId();

const team = ref([]);
const selectedIndex = ref(0);
const evolutionResult = ref(null);
const showTip = ref(false);

const formattedPokemons = computed(() => {
  const max = 6;
  return [...team.value, ...Array(max - team.value.length).fill(null)];
});

const fetchTeam = async () => {
  const res = await proxy.$axios.get(`/pokemon/team/${userId}`);
  team.value = res.data;
  await checkEvolution();


};

const checkEvolution = async () => {
  const p = team.value[selectedIndex.value];
  if (!p) return;
  const res = await proxy.$axios.get(`/pokemon/evolution/check/${userId}/${selectedIndex.value + 1}`);
  evolutionResult.value = res.data;
};

const selectPokemon = async (index) => {
  selectedIndex.value = index;
  await checkEvolution();
};

const triggerEvolution = async () => {
  const res = await proxy.$axios.post('/pokemon/evolution/trigger', {
    userId,
    position: selectedIndex.value + 1,
  });
  evolutionResult.value = res.data;
  showTip.value = true;
  setTimeout(() => (showTip.value = false), 2000);
  await fetchTeam();
};


const currentPokemonNickname = computed(() => {
  const p = team.value[selectedIndex.value];
  return p ? p.nickname : '未知';
});



onMounted(fetchTeam);
</script>

<style scoped>
.evolution-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f5f5f5;
  font-size: 90%;
  box-sizing: border-box;
}

.pokemon-scroll-row {
  display: flex;
  overflow-x: auto;
  padding: 10px;
  background: #ffffff;
  gap: 10px;
}

.pokemon-card {
  min-width: 60px;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border: 2px solid #ccc;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pokemon-icon-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pokemon-icon {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

.pokemon-card.selected {
  border-color: #ff4444;
}

.main-section {
  flex: 1;
  padding: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
  text-align: center;
}

button {
  padding: 10px 20px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
}

button:disabled {
  background: #aaa;
  cursor: not-allowed;
}

.tip-popup {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 14px;
  z-index: 999;
}
</style>
